import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { CUBICLE_GRID_TYPE_ASSISTANCE_REQUEST, CUBICLE_GRID_TYPE_MY_LIST, CUBICLE_GRID_TYPE_SPECIAL_REQUEST } from '../../components/faculties/CubicleGrid';
import { createRequestLog } from '../../redux/actions/request_logs.actions';
import {
    CUBICLE_STATUS_OCCUPIED,
    CUBICLE_STATUS_UI_NAMES,
    CUBICLE_STATUS_UNOCCUPIED,
    REQUEST_STATUS_COMPLETED,
    REQUEST_STATUS_ON_QUEUE,
    CUBICLE_STATUS_SPECIAL_REQUEST,
    REQUEST_STATUS_UNDER_WAY,
    STATUS_ELIGIBLE_FOR_REQUEST_LOG,
} from '../../redux/reducers/my_cubicle.reducer';
import crossSVG from '../assets/svg/cancel-close-cross.svg';

export const CUBICLE_VARIANT_STUDENT_QUEUE = 'student-queue';
export const CUBICLE_VARIANT_FACULTY_HOME = 'faculty-home';
export const CUBICLE_VARIANT_NAVBAR = 'navbar';
export const CUBICLE_VARIANT_HEADER = 'header';
export const CUBICLE_VARIANT_CUBICLE_MAP = 'cubicle-map';

/* List of available values for attribue color. It is derived from Bootstrap color classes.
 * info, warning, danger, success, primary, secondary, transparent
 */

const Cubicle = ({ cubicleData, variant, gridType = null }) => {
    const dispatch = useDispatch();
    const proceduresMap = useSelector((state) => state.procedures.proceduresMap);
    const myCubicleId = useSelector((state) => state.myCubicle.id);
    const outlineClassPrefix = 'outline-';

    const footerDescriptionStyle = {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    };

    const getButtonColor = () => {
        if (
            cubicleData.cubicle_status === CUBICLE_STATUS_UNOCCUPIED ||
            [CUBICLE_VARIANT_HEADER, CUBICLE_VARIANT_NAVBAR].includes(variant)
        ) {
            return outlineClassPrefix + cubicleData.color;
        }

        return cubicleData.color;
    };

    const getFooterDescription = () => {
        if (
            [CUBICLE_VARIANT_NAVBAR, CUBICLE_VARIANT_HEADER].includes(variant)
        ) {
            return [];
        }

        if (
            [CUBICLE_STATUS_OCCUPIED, CUBICLE_STATUS_UNOCCUPIED].includes(
                cubicleData.cubicle_status
            )
        ) {
            // Single space just to render one row
            return [' '];
        }

        if (cubicleData.cubicle_status === CUBICLE_STATUS_SPECIAL_REQUEST) {
            return [cubicleData.last_cubicle_log.faculty_requested.last_name];
        }

        if (
            !cubicleData.last_cubicle_log?.procedures ||
            cubicleData.last_cubicle_log.procedures.length === 0
        ) {
            let statusName =
                CUBICLE_STATUS_UI_NAMES[cubicleData.cubicle_status];
            return statusName.split(' ');
        }

        return cubicleData.last_cubicle_log.procedures.map((procedureId) =>
            proceduresMap[procedureId] ? proceduresMap[procedureId] : null
        );
    };

    const onClickButtonHandler = () => {
        if (variant === CUBICLE_VARIANT_FACULTY_HOME) {
            if (
                [CUBICLE_GRID_TYPE_ASSISTANCE_REQUEST, CUBICLE_GRID_TYPE_SPECIAL_REQUEST].includes(gridType) &&
                cubicleData.request_status === REQUEST_STATUS_ON_QUEUE &&
                STATUS_ELIGIBLE_FOR_REQUEST_LOG.includes(
                    cubicleData.cubicle_status
                )
            ) {
                let requestLogData = {
                    cubicle_log: cubicleData.last_cubicle_log.id,
                    request_status: REQUEST_STATUS_UNDER_WAY,
                };
                dispatch(createRequestLog(requestLogData));
            } else if (
                gridType === CUBICLE_GRID_TYPE_MY_LIST &&
                cubicleData.request_status === REQUEST_STATUS_UNDER_WAY
            ) {
                let requestLogData = {
                    cubicle_log: cubicleData.last_cubicle_log.id,
                    request_status: REQUEST_STATUS_COMPLETED,
                };
                dispatch(createRequestLog(requestLogData));
            }
        }
    };

    const buttonColor = getButtonColor();
    let footerDescription = getFooterDescription();

    let btnStyle = {
        height: 60,
        width: 60,
        fontWeight: buttonColor.includes(outlineClassPrefix) ? 700 : 400,
        borderRadius: 8,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        padding: '0.6rem',
    };

    const buttonSize = variant === CUBICLE_VARIANT_NAVBAR ? 'sm' : 'lg';

    if (variant === CUBICLE_VARIANT_NAVBAR) {
        btnStyle.height = 33;
        btnStyle.width = 33;
        btnStyle.padding = 2;
    }

    if (cubicleData.is_enabled === false) {
        btnStyle.opacity = 0.8;
        btnStyle.backgroundImage = `url(${crossSVG})`;
        btnStyle.backgroundSize = 60;
        footerDescription = ['Disabled'];
    }

    if (
        cubicleData.id === myCubicleId &&
        ![CUBICLE_VARIANT_NAVBAR, CUBICLE_VARIANT_HEADER].includes(variant)
    ) {
        btnStyle.boxShadow = '0 0.3rem 2rem rgb(0 0 0 / 82%)';
    }

    return (
        <div className="d-inline-block me-md-0 me-2">
            <Button
                size={buttonSize}
                color={buttonColor}
                style={btnStyle}
                onClick={onClickButtonHandler}
            >
                {cubicleData.name}
            </Button>
            {footerDescription.length > 0 && (
                <div
                    className="fs-7 lh-sm text-center text-black-50 mt-2"
                    style={{ width: 60 }}
                >
                    <div key="0" style={footerDescriptionStyle}>
                        {footerDescription[0]}
                    </div>
                    {footerDescription.length > 1 && (
                        <div key="1" style={footerDescriptionStyle}>
                            {footerDescription[1]}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Cubicle;
